import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MediaCategory from 'src/config/MediaCategory';
import RoutePaths from 'src/config/RoutePaths';
import NewsDetail from 'src/pages/NewsDetail';
import ArticleAPI from 'src/services/api/ArticleAPI';
import withDisclaimer from 'src/utils/withDisclaimer';

export const getServerSideProps = async ({ locale, query, res }) => {
    const { articleUrl } = query;
    const category = MediaCategory.INSIGHTS;
    const resp = await ArticleAPI.getArticleDetailByIdOrUrl(encodeURI(articleUrl));
    if (resp.status && resp.data) {
        return {
            props: {
                ...(await serverSideTranslations(locale, ['common', 'disclaimer'])),
                category,
                articleUrl,
                article: resp.data,
            },
        };
    }
    res.writeHead(301, {
        Location: RoutePaths.HOME,
    });
    res.end();
    return {};
};

export default withDisclaimer()(NewsDetail);
